import React, { memo, useState, useEffect, useCallback, useRef, } from "react";
import { connect } from "react-redux";
import { Modal, Skeleton, message, Dropdown, Input, Popover } from "antd";
import DefaultAvatar from '@/assets/images/avatar_default.png';
import { renderTime, formatPrice } from "@/utils/common";
import { getUserBenefit, getRechargeStatus } from "@/api/index";
import { getVipPackageList, getNewVipPackageList, getUserCouponList, createOrder, checkPayResult, getQueneWorkList, transferToVipTask, getTopsPackageList, exchangeTops } from "@/api";
import QRCode from 'qrcode'
import { LlwMemberGoodsSelect, LlwAiRechargeShow } from "@/utils/sensorsFunc";
import { debounce } from "lodash";
import NoCouponIcon from '@/assets/images/icon_no_coupon.png';
import store from "@/store";
import Confirm from '../../views/AIEditV3/components/Confirm';
import { REDRAW_NAME } from "@/views/AIEditV3/consts";

import s from "./index.module.less";
import VipIcon1 from '@/assets/images/newVip/vip-icon1.png';
import VipIcon2 from '@/assets/images/newVip/vip-icon2.png';
import VipIcon3 from '@/assets/images/newVip/vip-icon3.png';
import HashrateIcon1 from '@/assets/images/newVip/hashrate-icon1.png';
import HashrateIcon2 from '@/assets/images/newVip/hashrate-icon2.png';
import HashrateIcon3 from '@/assets/images/newVip/hashrate-icon3.png';
import wxLogo from '@/assets/images/newVip/wx.png';
import zfbLogo from '@/assets/images/newVip/zfb.png';
import EquityModal from './EquityModal'
import UpgradeModal from './UpgradeModal'
import VipHeader from "./VipHeader/index";
import { VIP_TYPE_MAP } from '@/consts/newConsts'
import Loading from '@/componentsNew/Loading';


const { getState } = store;
const VipRecharge = (props) => {
  const { visible, userInfo, memberLocation, setVisible, setUserInfo, setModalOperation, isLykPayModalOpen, onAfterClose,
    reDrawMode, setUserTemporaryTops, ai_source, userTemporaryTops, vipRechargeTab, setVipRechargeTab, setRechargeSuccessVersion } = props;

  const [packageData, setPackageData] = useState(null); // 套包数据- 月套包列表和年套包列表
  const [packageList, setPackageList] = useState([]); // 套包列表
  const [topsPackageList, setTopsPackageList] = useState([]); // 算力套包列表
  const [packageItem, setPackageItem] = useState({}); // 当前选择的套包
  const [topsPackageItem, setTopsPackageItem] = useState({}); // 当前选择的算力套包
  const [unionType, setUnionType] = useState(0); // 是否聚合支付：1-旧支付(微信or支付宝)，2-聚合支付(一个聚合二维码)
  const [CZType, setCZType] = useState(0); // 支付方式：0-微信，1-支付宝 2-下载币 3-paypal
  const [couponList, setCouponList] = useState([]); // 可用优惠券下拉选项
  const [couponItems, setCouponItems] = useState([]); // 可用优惠券下拉选项
  const [couponItem, setCouponItem] = useState(null); // 当前选用的优惠券
  const [qrCodeUrl, setQrCodeUrl] = useState(''); // 二维码url
  const [jkma, setJKMA] = useState('');  // 订单号
  const [isExpired, setIsExpired] = useState(false); // 二维码是否过期
  const [isXZBRecharge, setIsXZBRecharge] = useState(false); // 是否充值过下载币，上报时用
  const [showFrameBox, setShowFrameBox] = useState(false); // 显示/隐藏支付宝支付iframe
  const [couponSelectText, setCouponSelectText] = useState(''); // 优惠券select text
  const [couponDropdownVisible, setCouponDropdownVisible] = useState(false); // 优惠券dropdown是否显示
  // const [userAvatar, setUserAvatar] = useState('') //用户头像
  const [confirmVisible,setConfirmVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('vip'); // vip-会员, power-算力
  const [vipType, setVipType] = useState(0); // 0-月卡，1-年卡
  const [equityVisible, setEquityVisible] = useState(false) // 更多权益
  const [rechargeStatus, setRechargeStatus] = useState(null); // 充值历史状态（getRechargeStatus），用于曝光埋点

  // 充值弹窗曝光埋点：按实际展示的 tab 上报（active_type 1-会员充值 2-算力充值），
  // 避免使用入口参数 vipRechargeTab 导致「余额不足自动进入算力 tab 场景」参数错误；用户手动切换 tab 时重新上报
  useEffect(() => {
    if (!visible || !rechargeStatus) return
    LlwAiRechargeShow({
      canvas_function: REDRAW_NAME[reDrawMode],
      is_recharge_suanli: rechargeStatus.is_tops_recharge,
      is_recharge_xzb: rechargeStatus.is_xzb_recharge,
      suanli_balance: userTemporaryTops,
      vip_type: userInfo?.vip_type,
      active_type: activeTab === 'vip' ? '1' : '2',
      member_location: memberLocation,
    })
  }, [visible, rechargeStatus, activeTab])

  const timerRef = useRef(null);
  const [isAllowedDeduct, setIsAllowedDeduct] = useState(false); // 月卡无法抵扣
  const [qrLoading, setQrLoading] = useState(false); // 二维码生成loading
  
  const changeVipType = (type) => {
    setVipType(type);
    const typeKey = type === 0 ? 'month' : 'year';
    const list = packageData[typeKey]?.list || [];
    setPackageList(list);
    const defaultPackageItem = list.filter(item => item.default_package === 1);
    const _packageItem = defaultPackageItem.length ? defaultPackageItem[0] : list[list.length - 1];
    setPackageItem(_packageItem);
    setUnionType(1);
    setCZType(0);
  }

  useEffect(() => {
    if (visible) {
      // if(!userAvatar){
      //   setUserAvatar(userInfo?.avatarurl || DefaultAvatar) // 优化套包切换时头像闪缩问题
      // }
      if(vipRechargeTab === 'power' || userInfo?.total_tops < 0){
        setActiveTab('power');
      }else{
        setActiveTab('vip');
      }
      clearTimer();
      // 套餐列表
      // getVipPackageList().then(res => {
      //   const list = res.data;
      //   if (list.length > 0) {
      //     const defaultPackageItem = list.filter(item => item.default_package === 1);
      //     setPackageList(list);
      //     const _packageItem = defaultPackageItem.length ? defaultPackageItem[0] : list[list.length - 1];
      //     setPackageItem(_packageItem);

      //     // 查询是否为聚合支付 20251028:根据后端反馈，去掉聚合支付查询
      //     // getUnionRechargeAB({
      //     //   order_type: '40'
      //     // }).then(res => {
      //     //   if(res.data){
      //     //     setUnionType(res.data);
      //     //   }else{
      //     //     setUnionType(1)
      //     //   }
      //     //   // setUnionType(1);
      //     // })
      //     setUnionType(1);
      //   }
      // });

      // 新VIP分组套包
      getNewVipPackageList().then(res => {
        if(res.status === 200){
          const data = res.data;
          setPackageData(data);
          setVipType(0);
          const list = data['month']?.list || [];
          setPackageList(list);
          const defaultPackageItem = list.filter(item => item.default_package === 1);
          const _packageItem = defaultPackageItem.length ? defaultPackageItem[0] : list[list.length - 1];
          setPackageItem(_packageItem);
          setUnionType(1);
          setCZType(0);
        }
      });


      //算力套餐列表
      getTopsPackageList().then(res =>{
          const list = res.data;
          if (list.length > 0) {
              const defaultPackageItem = list.filter(item => item.default_package === 1);
              const tops66PackageItem = list.find(item => Number(item.tops) === 66);
              setTopsPackageList(list);
              const _packageItem = tops66PackageItem
                || (defaultPackageItem.length ? defaultPackageItem[0] : list[list.length - 1]);
              setTopsPackageItem(_packageItem);
          }
      })


      getRechargeStatus().then(res => {
        const { data, status } = res;
        if(status !== 200 || !data) return
        const { is_tops_recharge, is_xzb_recharge } = data
        setIsXZBRecharge(!!is_xzb_recharge)
        // 充值状态存入 state，由独立 effect 结合实际展示 tab 上报曝光埋点
        setRechargeStatus({ is_tops_recharge: !!is_tops_recharge, is_xzb_recharge: !!is_xzb_recharge })
      });
    } else {
      setCouponItem(null);
      setVipRechargeTab('vip'); // 关闭后重置默认tab，避免影响其他入口
    }
  }, [visible])


  const clearTimer = () => {
    timerRef.current && clearInterval(timerRef.current);
    timerRef.current = null;
  }

  // 埋点上报
  const goodsSelectReport = jkma => {
    let params = {
      goods_id: jkma, // 订单号
      goods_name: packageItem.package_name, // 订单名称
      asset_type: 1, // 主体类型 1：个人 2：企业
      is_recharge_xzb: isXZBRecharge
    }
    if(memberLocation == 14 || memberLocation == 19 || memberLocation == 27){
      params['change_tfunction'] = reDrawMode + 1
      params['canvas_function'] = REDRAW_NAME[reDrawMode]
    }
    LlwMemberGoodsSelect(params);
  }

  // 查询可用优惠券
  const initCouponList = (_packageItem) => {
    getUserCouponList({
      price: +_packageItem.package_fee,
      cz_channel: 27,
      package_id: _packageItem?.vip_package_id || _packageItem?.id
    }).then(res => {
      const list = res?.data;
      setCouponList(list);
      if (list.length) {
        setCouponItem(list[0]);
        setCouponSelectText(`满${list[0].use_limit_price || '--'}元-${list[0].coupon_price || ''}`);
        const _couponItems = list.map(coupon => {
          return {
            key: coupon.coupon_id,
            label: (
              <div className={`${s.couponItem} coupon-item`}>
                <div className={s.couponItemLeft}>
                  <div className={`${s.couponMoney} coupon-money`}><span>￥</span>{coupon.coupon_price}</div>
                  <div className={`${s.couponDesc} coupon-desc`}>满{coupon.use_limit_price}元可用</div>
                </div>
                <div className={s.couponItemRight}>
                  <div className={`${s.couponName} coupon-name`}>{coupon.coupon_title}</div>
                  <div className={`${s.couponText} coupon-text`}>{coupon.coupon_end_time}</div>
                </div>
              </div>
            )
          }
        });
        setCouponItems(_couponItems);
      } else {
        setCouponItem({});
        setCouponSelectText('无可用优惠券');
        setCouponItems([{
          key: 1,
          label: (
            <div className={s.noCoupon}>
              <img src={NoCouponIcon} />
              <div className={s.text}>无可用优惠券</div>
            </div>
          )
        }]);
      }
    })
  }

  const getCZSource = () =>{
    const ai_source = +getState().app.ai_source;
    if(ai_source === 300){
        return '3'; // ps插件
    }
    return [6, 7, 10, 11, 12, 30].includes(ai_source) ? '2' : '1' // 1-web站点 2-溜云库站点
  }

  // 下单
  const genOrderQRCode = (package_item, union_type, cz_type, coupon_item, member_location, reDraw_mode, tops_package_item, activeTab) => {
    if (activeTab === 'vip' ? !package_item?.vip_package_id : !tops_package_item?.id) return;
    if (union_type === 0) return;
    if (cz_type === 2) return; //使用下载币兑换算力
    if (!coupon_item) return;

    setQrLoading(true);
    const params = {
      package_id: activeTab === 'vip'? package_item.vip_package_id : tops_package_item.id, // 套包ID
      cz_type: union_type === 1 ? cz_type : 0, // 支付方式
      qrcode_size: '140', // 二维码尺寸
      is_union: union_type === 2 ? 1: 0, // 是否为聚合支付
      coupon_id: coupon_item.coupon_id || 0, // 优惠卷ID
      order_type: activeTab === 'vip' ? '40' : '51', // 订单类型: 40-会员充值 51-算力充值
      entrance: '12', // 来源
      cz_source: getCZSource(),
      member_location: member_location
    };
    if(member_location == 14 || member_location == 19 || member_location == 27){
      params.redraw_mode = reDraw_mode + 1
      params.canvas_function = REDRAW_NAME[reDraw_mode]
    }
    const formData = new FormData();
    formData.append('data', JSON.stringify(params));
    createOrder(formData).then(res => {
      if (res.status === 0) {
        if(res.msg === '月卡无法抵扣购买'){
          clearTimer();
          setQrCodeUrl('');
          setShowFrameBox(false);
          setIsAllowedDeduct(true);
          setIsExpired(false);
          setQrLoading(false);
          return
        }
        message.error(res.msg || '请求出错了，请稍候重试');
        setQrLoading(false);
        return;
      }
      const { jkma, qrcode } = res.data;
      setJKMA(jkma);
      setIsExpired(false);
      setIsAllowedDeduct(false);
      clearTimer();
      // 选择支付宝支付时，使用iframe展示付款二维码
      if (cz_type === 1) { //union_type === 1 &&
        // console.log('=============支付宝url===============',qrcode)
        setQrCodeUrl(qrcode);
        // iframe先加载，再展示
        setTimeout(() => {
          setShowFrameBox(true);
        }, 1000);
      } else { // url转二维码图片
        // console.log('=============url转二维码图片===============',qrcode)
        QRCode.toDataURL(qrcode, {
          height: 140,
          wight: 140,
          margin: 1
        }).then(res => {
          setQrCodeUrl(res);
        })
      }
      // 埋点上报
      goodsSelectReport(jkma);
      setQrLoading(false);
    })
  }

  // 定义套包切换防抖
  const debouncedInitCouponList = useCallback(
    debounce((packageItem) => {
      // console.log('package item clicked!', packageItem);
      if (packageItem.vip_package_id||packageItem.id) {
        initCouponList(packageItem);
      }
    }, 1000),
    [] // 空数组作为依赖，确保函数不会在重渲染时重新创建
  );

  useEffect(() => {
    debouncedInitCouponList(packageItem);
    // 确保在组件卸载时清除防抖定时器
    return () => debouncedInitCouponList.cancel();
  }, [packageItem, debouncedInitCouponList]);

  useEffect(() => {
    debouncedInitCouponList(topsPackageItem);
    // 确保在组件卸载时清除防抖定时器
    return () => debouncedInitCouponList.cancel();
  }, [debouncedInitCouponList, topsPackageItem]);
  
  // 定义支付方式切换防抖
  const debouncedGenOrderQRCode = useCallback(
    debounce((packageItem, unionType, CZType, couponItem, memberLocation, reDrawMode, topsPackageItem, activeTab) => {
      //console.log('cz_type clicked!',  unionType, CZType, couponItem, memberLocation);
      genOrderQRCode(packageItem, unionType, CZType, couponItem, memberLocation, reDrawMode, topsPackageItem, activeTab);
    }, 1000),
    [] // 空数组作为依赖，确保函数不会在重渲染时重新创建
  );

  useEffect(() => {
    debouncedGenOrderQRCode(packageItem, unionType, CZType, couponItem, memberLocation, reDrawMode,topsPackageItem, activeTab );
    // 确保在组件卸载时清除防抖定时器
    return () => debouncedGenOrderQRCode.cancel();
  }, [CZType, debouncedGenOrderQRCode, activeTab]);

  useEffect(() => {
    genOrderQRCode(packageItem, unionType, CZType, couponItem, memberLocation, reDrawMode, topsPackageItem, activeTab);
  }, [unionType, couponItem])

  useEffect(() => {
    if (visible && qrCodeUrl) {
      timerRef.current = setInterval(() => {
        const formData = new FormData();
        formData.append('service', 'll.order.check');
        formData.append('jkma', jkma);
        formData.append('cz_channel', activeTab === 'vip' ? '40' : '51');
        formData.append('is_union', unionType === 2 ? '1' : '0');
        checkPayResult(formData).then(res => {
          // 充值成功or续充成功
          if (res.status === 200) {
            clearTimer();
            setShowFrameBox(false);
            setQrCodeUrl('');
            // 重新查询
            getUserBenefit().then(res => {
              if(res.status !== 200 || !res.data) return
              const updatedUserInfo = { ...userInfo, ...res.data };
              setUserTemporaryTops(res.data.total_tops)
              setUserInfo(updatedUserInfo);
              localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
              setIsPaySuccessVisible(true)
              // 充值成功会赠送免费次数/算力，递增版本号通知页面重新拉取算力报价
              setRechargeSuccessVersion(getState().edit.rechargeSuccessVersion + 1)
            })
            // 开VIP插队
            if (memberLocation === 22) {
              getQueneWorkList().then(res => {
                const workList = res.data;
                for (let i = 0; i < workList.length; i++) {
                  transferToVipTask({
                    work_id: workList[i]
                  });
                }
              })
            }
            // 调用溜云库方法, ps插件不调用
            if(isLykPayModalOpen && +ai_source === 30){
              setModalOperation({type: 'modalPaySuccess', data: res})
            }
           
          } else if (res.status === 401) { // 二维码过期失效
            clearTimer();
            setIsExpired(true);
          }
        }) 
      }, 2000)
      return () => {
        clearInterval(timerRef.current);
      }
    }
  }, [qrCodeUrl,jkma])


  // 权益列表
  const entitlementList = [
    ['生图/改图/渲染任务', '专属高速服务器', '支持4K及以上高清下载', '下载无水印'],
    ['生图/改图/渲染任务', '专属高速服务器', '支持4K及以上高清下载', '下载无水印'],
    ['生图/改图/渲染任务', '专属高速服务器', '支持4K及以上高清下载', '下载无水印','新增功能优先体验'],
  ]


  const selectCouponItem = (item) => {
    if (couponItem.coupon_id === +item.key) {
      setCouponItem({});
      setCouponSelectText('不使用优惠券');
    } else if (couponList.length) {
      // $element.classList.add('coupon-item-active');
      const _couponItem = couponList.find(x => x.coupon_id === +item.key);
      setCouponItem(_couponItem || {});
      setCouponSelectText(`满${_couponItem.use_limit_price || '--'}元-${_couponItem.coupon_price || ''}`);
    }
    setCouponDropdownVisible(false);
  };

  useEffect(() => {
    if (couponDropdownVisible) {
      // 弹框外层元素
      const $rechargeWrap = document.getElementById('rechargeWrap');
      // 优惠券下拉框元素
      const $couponSelectWrap = document.getElementById('couponSelectWrap');
      // 点击的地方不是优惠券下拉框范围内时，关闭优惠券下拉框
      const handleClick = e =>{
        if (!$couponSelectWrap.contains(e.target)) {
          setCouponDropdownVisible(false);
        }
      }
      $rechargeWrap.addEventListener('click', handleClick);

      return () => {
        $rechargeWrap.removeEventListener('click', handleClick);
      }
    }
  }, [couponDropdownVisible])

  // 关闭模态框方法
  const closeModal = () => {
    if(isLykPayModalOpen && +ai_source === 30){
      // 调用溜云库方法
      setModalOperation({type: 'modalClose', data: {}})
    }else{
      clearTimer(); 
      setVisible(false)
    }
  };
  const [isPaySuccessVisible, setIsPaySuccessVisible] = useState(false);
  const confirmSuccess = () => { // 确认充值成功
    if(+ai_source === 300){
      setIsPaySuccessVisible(false);
    }else{
      setIsPaySuccessVisible(false);
      let t = setTimeout(() => { 
        closeModal();
        clearTimeout(t);
      }, 500);
    }
  };

  //提交下载币充值
  const onSubmitExchangeTops = async() => {
     const tops = Number(topsPackageItem.tops)
     try{
      let params = {
        tops: tops,
        member_location: memberLocation,
        package_id: topsPackageItem.id
      };
      if(memberLocation == 14 || memberLocation == 19 || memberLocation == 27){
        params.canvas_function = REDRAW_NAME[reDrawMode]
      }
      const res = await exchangeTops(params)
      if(res.status === 200){
          message.success('兑换成功')
          //重新查询
          const storedUserInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
          getUserBenefit().then(res => {
            if (res.status == 200) {
              const updatedUserInfo = { ...storedUserInfo, ...res.data };
              localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
              setUserInfo(updatedUserInfo);
              setUserTemporaryTops(updatedUserInfo.total_tops)
              // 兑换成功更新算力余额，递增版本号通知页面重新拉取算力报价
              setRechargeSuccessVersion(getState().edit.rechargeSuccessVersion + 1)
            }
          });
      }else{
          message.error(res.msg)
      }
     }catch(error){}
  }

  return (
    <Modal
      wrapClassName={s.modal}
      zIndex={1400}
      open={visible}
      onCancel={closeModal}
      afterClose={() => onAfterClose?.(activeTab)}
      centered
      destroyOnClose={true}
      closable={false}
      footer={null}
      mask={isLykPayModalOpen ? false : true}
      maskClosable={isLykPayModalOpen ? false : true}
    > 
      {isLykPayModalOpen && +ai_source === 300 ? null : 
      <div className='closeBtn' onClick={closeModal}>
        <i className='iconfont icon-lujing3'></i>
      </div>
      }
      {activeTab === 'vip' ? (
        <div className={s.vipModal} id="rechargeWrap">
          <VipHeader userInfo={userInfo} activeTab={activeTab} onSwitchTab={setActiveTab} packageItem={packageItem} hideRechargeButton />
          <div className="content">
            <div className="leftPannel">
              <div className="topBox">
                <div className="tabBox">
                  <div className={`tab${vipType === 0 ? ' selectTab' : ''}`} onClick={() => changeVipType(0)} >
                    月卡订阅
                  </div>
                  <div className={`tab${vipType === 1 ? ' selectTab' : ''}`} onClick={() => changeVipType(1)} >
                    年卡订阅
                  </div>
                </div>
                <div className="ruleBtn" onClick={() => setEquityVisible(true)}>
                  <span>会员权益规则{' >'}</span>
                </div>
                <div className="topRechargeBtn" onClick={() => setActiveTab('power')}>
                  充值算力
                </div>
              </div>
              <div className="packageBox">
              {
                packageList.map((item, index)=> {
                  const classIndex= index + 1;
                  const VipIcons = [VipIcon1, VipIcon2, VipIcon3];
                  const HashrateIcons = [HashrateIcon1, HashrateIcon2, HashrateIcon3];
                  const packageUnit = vipType === 0 ? '月' : '年';
                  return (
                    <div
                      className={`pgItem${classIndex}`}
                      data-selected={String(item.vip_package_id) === String(packageItem.vip_package_id)}
                      key={item.vip_package_id}
                      onClick={() => { setQrCodeUrl(''); setShowFrameBox(false); setIsExpired(false); setIsAllowedDeduct(false); setPackageItem(item); }}
                    >
                      <div className="pgTitle">
                        <img className="pgTitleIcon" src={VipIcons[index]} alt="" />
                        <span className="pgTitleTxt">{item.package_name}</span>
                      </div>
                      <div className="priceBox">
                        <div className="price">
                          <span className="priceSymbol">￥</span>
                          <span className="priceNum">{item.package_fee}</span>
                          <span className="priceUnit">每{packageUnit}</span>
                        </div>
                        <div className="priceDsc">
                          {vipType === 1 && (
                            <span className="priceDscText">¥{(item.package_fee / 12).toFixed(1)}/每月</span>
                          )}
                          {item.package_explain && (
                            <span className="priceDscText">{item.package_explain}</span>
                          )}
                        </div>
                      </div>
                      <div className="priceLight">
                        <div className="sendTxt">
                          <img src={HashrateIcons[index]} alt=""/>
                          <div className="lg_txt">送{item.tops}免费算力/月</div>
                        </div>
                        {item.ai_rendering_num !== 0 && (
                        <div className="sendDsc2">
                          <div className="discount">每月{item.ai_rendering_num}次</div>
                          <span>免费AI渲染</span>
                        </div>
                        )} 
                        <div className="sendDsc">
                          约可生成<span>{item.generate_img_num}+ </span>张图 
                        </div>
                      </div>
                      <div className="equityList">
                        {entitlementList[index]?.map((title, idx) => (
                          <div className="equityItem" key={idx}>
                            <i className='iconfont icon-rongqi5'></i>
                            <span>{title}</span>
                            {idx === 0 && (
                              <div className="discount">享{item.use_tops_discount}折</div>
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="moreTips">更多权益开发中...</div>
                    </div>
                  )
                })
              }
              </div>
            </div>
            <div className="rightPannel">
              <div className="priceBox">
                {/* 仅旧会员（旧升新可抵扣用户）展示「以旧换新」标签，与下方抵扣提示条件一致 */}
                {packageData?.upgrade_info?.is_ll_ai_vip === 1 && <div className="priceTag">以旧换新</div>}
                <div className="priceSymbol">￥</div>
                <div className="price">
                  {formatPrice(isAllowedDeduct ? Number(packageItem.package_fee) : Math.max(0.01, Number(packageItem.package_fee) - Number(couponItem?.coupon_price || 0) - Number(packageData?.upgrade_info?.discount_price || 0)))}
                  </div>
              </div>
              <div className="tipsBox">
                {!isAllowedDeduct && <div className="tips">已优惠 ¥{formatPrice(Number(couponItem?.coupon_price || 0) + Number(packageData?.upgrade_info?.discount_price || 0))}</div>}
                {!isAllowedDeduct && packageData?.upgrade_info?.is_ll_ai_vip === 1 && (
                  <Popover placement="top" title={''} color='#111111' rootClassName="popover-arrow-at-left" arrow={false} 
                  content={()=>{
                    return (
                    <div style={{color:"#ffffff"}}>
                      <div>旧升新抵扣：</div>
                      <div>旧会员已发放算力不做抵扣</div>
                      <div>旧会员剩余时长{packageData.upgrade_info?.remain_days || 0}天</div>
                      <div>共抵扣：{formatPrice(packageData.upgrade_info?.discount_price)}元</div>
                      <div>用券优惠: {formatPrice(couponItem?.coupon_price)}</div>
                    </div>)
                  }}>
                    <i className='iconfont icon-doubt'></i>
                  </Popover>
                )}
              </div>
              <div className="couponBox">
                <div className="couponTitle">优惠券</div>
                <div className="coupon-select-wrap" id="couponSelectWrap">
                  <Dropdown
                      menu={{
                        items: couponItems,
                        onClick: selectCouponItem,
                        selectedKeys: couponItem && couponItem.coupon_id ? [`${couponItem.coupon_id}`] : []
                      }}
                      open={couponDropdownVisible}
                      trigger={['click']}
                      overlayClassName={`coupon-dropdown ${couponItems.length && couponItems[0].key === 1 ? 'no-coupon' : ''}`}
                      getPopupContainer={() => {
                        return document.getElementById('couponSelectWrap');
                      }}
                    >
                      <Input placeholder="请选择优惠券" value={couponSelectText} readOnly 
                        onClick={() => setCouponDropdownVisible(!couponDropdownVisible)} />
                  </Dropdown>
                  <span span className="ant-input-arrow" onClick={() => setCouponDropdownVisible(!couponDropdownVisible)}></span>
                </div>
              </div>
              <div className={`codeBox ${CZType === 0 ? 'wxbg' : 'zfbbg'}`}>
                <div className="payBtnList">
                  <div className="wxBtn" onClick={() => { setQrCodeUrl(''); setShowFrameBox(false); setCZType(0) }}>
                    <img src={wxLogo} alt="wxLogo"/>
                    {CZType === 0 && <span>微信支付</span>}
                  </div>
                  <div className="zfbBtn" onClick={() => { setQrCodeUrl(''); setShowFrameBox(false); setCZType(1) }}>
                    <img src={zfbLogo} alt="zfbLogo"/>
                    {CZType === 1 && <span>支付宝支付</span>}
                  </div>
                </div>
                <div className="qrCodeBox">
                  <div className="codeImage">
                    { unionType ===1 && CZType === 1 && qrCodeUrl ?
                    <div className="iframeBox">
                      <iframe src={qrCodeUrl} width="140" height="140" frameBorder="0" scrolling="no" style={{ display: showFrameBox ? '' : 'none' }} />
                      { !showFrameBox && <Skeleton.Image active={true} style={{ width: 140, height: 140 }} /> }
                    </div>
                    :
                    qrCodeUrl ? 
                    <img src={qrCodeUrl} />
                    :
                    !isAllowedDeduct && !qrLoading && <Skeleton.Image
                      active={true}
                      style={{
                        width: 140,
                        height: 140
                      }}
                    /> 
                    }
                    { qrLoading && <div className="qrLoading"><Loading /></div> }
                    { isExpired && <div className='mask' onClick={() => genOrderQRCode(packageItem, unionType, CZType, couponItem, memberLocation, reDrawMode, topsPackageItem, activeTab)}>
                      <div>二维码失效</div>
                      <div>请点击<span className='btn'>刷新</span></div>
                    </div> }
                    { isAllowedDeduct && !qrLoading && (
                      <div className='mask'>
                        <div>月卡无法抵扣购买</div>
                      </div>
                    )}
                    { unionType === 2 && <div className='textBox'><span className={`tag wx`}></span><span className={`tag zfb`}></span><span className='text'>微信/支付宝</span></div>}
                  </div>
                </div>
              </div>
              <div className="footerBar">
                <a href="https://service.3d66.com/rule/6.html" target="_blank" rel="noopener noreferrer">支付即表示同意《3D溜溜网用户协议》</a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={s.topsModal} id="rechargeWrap">
          <VipHeader userInfo={userInfo} activeTab={activeTab} onSwitchTab={setActiveTab} packageItem={packageItem} />
          <div className="content">
            <div className="packageList" >
              {
                topsPackageList.map((item)=> {
                  return (
                    <div key={item.vip_package_id} className={`item ${ item.id === topsPackageItem.id ? 'active' : ''}`} onClick={() => { 
                      setQrCodeUrl(''); 
                      setShowFrameBox(false); 
                      setTopsPackageItem(item);
                    }}>
                      <div className="name">
                        <div className={s.iconTops}></div>
                        <span>{item.package_name}</span>
                      </div>
                      <div className="price">
                        <span className="priceSymbol">￥</span>
                        <span className="priceNum">{item.package_fee}</span>
                      </div>
                      <div className="originPrice">原价：￥{item.original_price}</div>
                      {item.package_explain && <div className="explainBar">{item.package_explain}</div>}
                    </div>
                  )
                })
              }
            </div>
            <div className="paymentBox">
              <div className="formItem">
                <label className='label'>
                  <i className="iconfont icon-zhifufangshi"></i>
                  <span>支付方式：</span>
                </label>
                <ul className="btnList">
                  <li className={`item wx ${CZType === 0 ? 'active' : ''}`} onClick={() => { setQrCodeUrl(''); setShowFrameBox(false); setCZType(0) }}>微信支付</li>
                  <li className={`item zfb ${CZType === 1 ? 'active' : ''}`} onClick={() => { setQrCodeUrl(''); setShowFrameBox(false); setCZType(1) }}>支付宝</li>
                  <li className={`item xzb ${CZType === 2 ? 'active' : ''}`} onClick={() => { setQrCodeUrl(''); setShowFrameBox(false); setCZType(2) }}>下载币</li>
                </ul>
              </div>
              {CZType !== 2 && (
              <div className={`formItem ${unionType === 1 ? 'mt' : ''}`}>
                <label className='label'>
                <i className="iconfont icon-youhuiquan"></i>
                  <span>优惠信息：</span>
                </label>
                <div className="coupon-select-wrap" id="couponSelectWrap">
                <Dropdown
                    menu={{
                      items: couponItems,
                      onClick: selectCouponItem,
                      selectedKeys: couponItem && couponItem.coupon_id ? [`${couponItem.coupon_id}`] : []
                    }}
                    open={couponDropdownVisible}
                    trigger={['click']}
                    overlayClassName={`coupon-dropdown ${couponItems.length && couponItems[0].key === 1 ? 'no-coupon' : ''}`}
                    getPopupContainer={() => {
                      return document.getElementById('couponSelectWrap');
                    }}
                  >
                    <Input style={{ width: 256, cursor: 'pointer' }} placeholder="请选择优惠券" value={couponSelectText} readOnly 
                      onClick={() => setCouponDropdownVisible(!couponDropdownVisible)} />
                </Dropdown>
                <span className="ant-input-arrow" onClick={() => setCouponDropdownVisible(!couponDropdownVisible)}></span>
                </div>
              </div>
              )}
              <div className="qrCodeBox">
                <div className="image">
                  { CZType === 1 && qrCodeUrl ?
                    <div className="iframeBox">
                      <iframe src={qrCodeUrl} width="140" height="140" frameBorder="0" scrolling="no" style={{ display: showFrameBox ? '' : 'none' }} />
                      { !showFrameBox && <Skeleton.Image active={true} style={{ width: 140, height: 140 }} /> }
                    </div>
                    :
                    CZType === 0 && qrCodeUrl ? 
                      <img src={qrCodeUrl} />
                    :
                    CZType === 2 ? 
                    <>
                      <div className="priceCon">
                        <div className="priceText">
                          <div className="topsPrice">{topsPackageItem.tops}</div>
                          <span>下载币</span>
                          <Popover placement="topLeft" title={''} color='#111111' rootClassName="popover-arrow-at-left" content={()=>{
                            return (
                            <div style={{color:"#ffffff"}}>
                              <div>1.使用下载币支付，将无法开具发票</div>
                              <div>2.价值换算：1下载币=1算力</div>
                            </div>)
                          }}>
                            <i className='iconfont icon-doubt'></i>
                          </Popover>
                        </div>
                        {couponItem && couponItem.coupon_price && CZType !== 2 &&
                        <div className="couponText" style={{ visibility: couponItem.coupon_price ? 'visible' : 'hidden' }}>
                          已优惠{couponItem.coupon_price}元
                        </div>
                        }
                      </div>
                      <div className="xzbQrBox_operate">
                        {Number(userInfo.download_coins||0) >= Number(topsPackageItem.tops||0) ? 
                          <button className="xzbQrBox_operate_yes" onClick={()=>{setConfirmVisible(true)}}>
                            确认兑换
                          </button> 
                          :
                          <button className="xzbQrBox_operate_no" disabled={true}>余额不足</button>
                        }
                      </div>
                    </>
                    :
                    <Skeleton.Image
                      active={true}
                      style={{
                        width: 140,
                        height: 140
                      }}
                    /> 
                  }
                  { isExpired && <div className="mask" onClick={() => genOrderQRCode(packageItem, unionType, CZType, couponItem, memberLocation, reDrawMode, topsPackageItem, activeTab)}>
                    <p>二维码失效</p>
                    <p>请点击<span className="btn">刷新</span></p>
                  </div> }
                </div>
                {CZType !== 2 &&  <div className={`priceCon ${unionType === 2 ? 'mb24' : ''}`}>
                  { topsPackageItem.id && couponItem && (
                    <div className="price">
                      <span className="priceSymbol">￥</span>
                      <span className="priceNum">{topsPackageItem.package_fee - (couponItem.coupon_price || 0)}</span>
                    </div>
                  )}
                  { couponItem && (
                    <div className="tipsBox">
                      <div className="tips">已优惠 ¥{couponItem.coupon_price || 0}</div>
                    </div>
                  )}
                  <div className="footerBar">
                    <a href="https://service.3d66.com/api/v1/DataApi/getCustomerServiceLink" target="_blank" rel="noopener noreferrer">支付遇到问题？联系客服</a>
                  </div>
                </div>}
              </div>
            </div>
          </div>
        </div>
      )}
     

      <Confirm 
        open={visible && confirmVisible} content={`确定使用${topsPackageItem.tops}下载币兑换${topsPackageItem.tops}算力?`}
        title={null} cancelBtnText="取消" okBtnText="确定"
        onClose={() => { setConfirmVisible(false) }} onCancel={() => { setConfirmVisible(false) }}
        onConfirm={() => { onSubmitExchangeTops();setConfirmVisible(false)}} 
      />

      {/* 充值成功弹窗 */}
      <Modal width={384} title={null} footer={null}  closeIcon={null} className={s.paySuccessModal}
      open={visible && isPaySuccessVisible} centered mask={false}>
        <div className={s.paySuccessModalCon}>
          <div className='titleBox'>
            <i className='iconfont icon-paysuccess'></i>
            <div className='title'>充值成功</div>
          </div>
          <div className="payInfoBox">
            <div className="payInfo" style={{marginBottom: '10px'}}>算力余额：{userInfo?.total_tops | 0}</div>
            {activeTab === 'vip' && (() => {
              // 根据订单发起时选中的套包类型，在 vip_info 中匹配当前充值套包的到期时间
              const vipType = packageItem?.type
              const vipInfoItem = (userInfo?.vip_info || []).find(item => item.vip_type === vipType)
              if (!vipInfoItem?.is_vip) return null
              const vipName = VIP_TYPE_MAP[vipType]
              return (
                <div className="payInfo">
                  { `${vipName}有效期至：${renderTime(vipInfoItem.vip_end_time*1000, 'YYYY年M月D日H时m分')}`}
                </div>
              )
            })()}
          </div>
          <div className="btnBox">
            <div className="btnBtn" onClick={confirmSuccess}>我知道了</div>
          </div>
        </div>
      </Modal>

      <EquityModal visible={visible && equityVisible} closeModal={() => setEquityVisible(false)} />
      <UpgradeModal visible={visible && packageData?.upgrade_info?.is_ll_ai_vip === 1 && packageData?.upgrade_info?.is_popup === 1} 
      discountNum={packageData?.upgrade_info?.discount_price}/>
    </Modal>
  );
};

const mapStateToProps = ({ app, work, edit }) => {
  return {
    userTemporaryTops: edit.userTemporaryTops,
    visible: app.vipRechargeModalVisible,
    userInfo: app.userInfo,
    vipRechargeTab: app.vipRechargeTab,
    memberLocation: app.memberLocation,
    isLykPayModalOpen: app.isLykPayModalOpen,
    reDrawMode: edit.reDrawMode,
    ai_source: app.ai_source,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setVisible: (params) => {
      return dispatch({
        type: "app/setVipRechargeModalVisible",
        payload: params
      });
    },
    setVipRechargeTab: (params) => {
      return dispatch({
        type: "app/setVipRechargeTab",
        payload: params
      });
    },
    setUserInfo: (params) => {
      return dispatch({
        type: "app/setUserInfo",
        payload: params
      });
    },
    setModalOperation: (params) => {
      return dispatch({
        type: "app/setModalOperation",
        payload: params
      });
    },
    setUserTemporaryTops:(params) => {
      return dispatch({
        type: "edit/setUserTemporaryTops",
        payload: params
      });
    },
    setRechargeSuccessVersion: (params) => {
      return dispatch({
        type: "edit/setRechargeSuccessVersion",
        payload: params
      });
    },
  };
};

export default memo(connect(mapStateToProps, mapDispatchToProps)(VipRecharge));
